import { useState, useEffect, useCallback } from 'react';
import api from '../../services/api';

// api.js GET okumalarında REJECT ETMEZ — .catch() ölü koddur. Gerçek sinyal res.data.status:
// başarısız/boş ayrımı ancak böyle yapılır.
export default function usePersonnelFile(employeeId) {
  const [fetching, setFetching] = useState(true);
  const [file, setFile] = useState(null);
  const [error, setError] = useState(false);
  const [tick, setTick] = useState(0);

  useEffect(() => {
    if (!employeeId) { setFetching(false); return; }
    setFetching(true);
    api.get(`/v1/personnel-files/${employeeId}`).then((res) => {
      if (res.data?.status) {
        setError(false);
        setFile(res.data.data);
      } else {
        setError(true);
        setFile(null);
      }
    }).finally(() => setFetching(false));
  }, [employeeId, tick]);

  const refresh = useCallback(() => setTick((p) => p + 1), []);

  return { fetching, file, error, refresh };
}
